import axios from "../../lib/axiosInstance";

export const createCategory = (payload) =>
  axios.post("/categories", payload).then((r) => r.data);

export const createSubCategory = (payload) => {
  return axios.post("/categories/subCategories", payload).then((r) => r.data);
};

export const createBulkVendor = (payload) =>
  axios.post("/categories/vendors/bulk", payload).then((r) => r.data);

export const fetchCategories = async (payload = {}) => {
  const queryParams = new URLSearchParams();

  if (payload.page) queryParams.append("page", payload.page);
  if (payload.limit) queryParams.append("limit", payload.limit);
  if (payload.search?.trim())
    queryParams.append("search", payload.search.trim());

  const res = await axios.get(`categories?${queryParams.toString()}`);
  return res.data;
};
export function fetchSubCategories(id) {
  return axios
    .get(`categories/subCategoriesByCategoryId/${id}`)
    .then((res) => res.data);
}

export function fetchVendors(id) {
  return axios
    .get(`categories/findAllVendorsByCategoryId/${id}`)
    .then((res) => res.data);
}

export const fetchAllVendors = async (payload = {}) => {
  const queryParams = new URLSearchParams();

  if (payload.page) queryParams.append("page", payload.page);
  if (payload.limit) queryParams.append("limit", payload.limit);
  if (payload.search?.trim())
    queryParams.append("search", payload.search.trim());

  const res = await axios.get(`categories/vendors?${queryParams.toString()}`);
  return res.data;
};

export const fetchAllSubCategories = async (payload = {}) => {
  const queryParams = new URLSearchParams();

  if (payload.page) queryParams.append("page", payload.page);
  if (payload.limit) queryParams.append("limit", payload.limit);
  if (payload.search?.trim())
    queryParams.append("search", payload.search.trim());

  const res = await axios.get(
    `categories/subCategories?${queryParams.toString()}`
  );
  return res.data;
};
